<template>
  <v-select
    v-model="model"
    :items="items"
    item-text="displayName"
    item-value="locationId"
    return-object
    :disabled="locked || !warehouseId"
    :clearable="clearable"
    label="Internal Location"
  />
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'WarehouseLocationSelectComponent',
  props: {
    warehouseId: {
      type: String,
      default: null,
    },
    location: {
      type: Object,
      default: null,
    },
    locked: {
      type: Boolean,
      default: false,
    },
    defaultPending: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    model: null,
    entries: [],
  }),
  computed: {
    items() {
      const entries = [...this.entries];
      if (this.location && this.location.locationId
        && !entries.some((entry) => entry.locationId === this.location.locationId)) {
        entries.unshift(this.location);
      }
      return entries.map((entry) => ({
        ...entry,
        displayName: entry.name,
      }));
    },
  },
  watch: {
    model(value) {
      this.$emit('onSetModel', value);
    },
    warehouseId() {
      this.model = null;
      this.getLocations();
    },
    location: {
      handler(value) {
        if (value && value.locationId) {
          this.model = value;
        }
      },
      deep: true,
    },
  },
  created() {
    this.model = this.location;
    this.getLocations();
  },
  methods: {
    ...mapActions('apiClient', ['get']),
    getLocations() {
      if (!this.warehouseId) {
        this.entries = [];
        return;
      }
      this.get({
        url: '/locations',
        params: { warehouseId: this.warehouseId, activeOnly: true },
      }).then((response) => {
        this.entries = response.data;
        if (this.location
          && this.location.warehouseId === this.warehouseId) {
          this.model = this.location;
        } else if (this.defaultPending) {
          this.model = this.entries.find((entry) => entry.name === 'Pending') || null;
        }
      });
    },
  },
};
</script>
